import { FUNC_DEFAULT } from 'constants';
import { PAYTO_LOG_TAG } from 'features/to/const';
import usePayto from 'features/to/hooks/payment/usePayto';
import usePaytoAPI from 'features/to/hooks/payment/usePaytoAPI';
import useCommonStore from 'hooks/useCommonStore';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import withAddPaytoAccountsAgreement from './withAddPaytoAccountsAgreement';

const withEditPaytoAccountAgreements = (Component) => {
  const EditPaytoAccountAgreementsComponent = withAddPaytoAccountsAgreement(
    (props) => {
      const { onSelect } = props || {};

      const { updatePaytoAccountAgreementById } = usePaytoAPI();
      const { setLoading } = useCommonStore();
      const { onShowEditPaytoAccountAgreementModal } = usePayto();

      const [bsbNumberMaskStr, setBsbNumberMaskStr] = useState('');
      const [accountNumberMaskStr, setAccountNumberMaskStr] = useState('');
      const [numberMaskStr, setNumberMaskStr] = useState('');

      const onEditPaytoAccountAgreement = (
        accountAgreement,
        callback = FUNC_DEFAULT,
        modalCallback = FUNC_DEFAULT
      ) => {
        try {
          if (isEmpty(accountAgreement)) {
            console.error(
              `🔥 ${PAYTO_LOG_TAG} ❌ onEditPaytoAccountAgreement ➡️ accountAgreement is empty ↩`
            );
            return;
          }

          setLoading(true);
          updatePaytoAccountAgreementById(accountAgreement, () => {
            modalCallback();
            setLoading(false);
            callback();
          });
        } catch (error) {
          console.error(
            `🔥 ${PAYTO_LOG_TAG} ❌ onEditPaytoAccountAgreement ➡️ ERROR ↩`,
            error?.message
          );
        }
      };

      const onOpenEditPaytoAccountModal = (
        accountAgreement,
        callback = FUNC_DEFAULT
      ) => {
        onShowEditPaytoAccountAgreementModal({
          modalData: accountAgreement,
          actionClose: () => {
            onSelect(accountAgreement);
          },
          action: (modalCallback) => {
            onEditPaytoAccountAgreement(
              accountAgreement,
              callback,
              modalCallback
            );
          },
        });
      };

      const newProps = {
        ...props,
        onEdit: onOpenEditPaytoAccountModal,
        bsbNumberMaskStr,
        setBsbNumberMaskStr,
        accountNumberMaskStr,
        setAccountNumberMaskStr,
        numberMaskStr,
        setNumberMaskStr,
      };
      return <Component {...newProps} />;
    }
  );
  return EditPaytoAccountAgreementsComponent;
};

export default withEditPaytoAccountAgreements;
